"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionTypeEnum = void 0;
var TransactionTypeEnum;
(function (TransactionTypeEnum) {
    TransactionTypeEnum["CREDIT"] = "CREDIT";
    TransactionTypeEnum["DEBIT"] = "DEBIT";
})(TransactionTypeEnum = exports.TransactionTypeEnum || (exports.TransactionTypeEnum = {}));
